import * as React from 'react';

import { SVG } from '@longline/aqua-ui/svg';
import { SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton';

import { useConfirm } from './ConfirmContext';

interface IProps {
  /** 
   * Should deletion be confirmed? 
   */
  confirm?: boolean;
  /** 
   * Tooltip and dialog title. 
   */
  title: string;
  /** 
   * Dialog body text. 
   */
  text: string;
  /** 
   * Fired when delete button is clicked (and confirmed, if necessary). 
   */
  onClick: () => void;
  /** 
   * If set, delete button is shown with an active animation. 
   */
  active?: boolean;
}

/**
 * A `DeleteButton` is a button that, when clicked, either just runs an 
 * onClick event (if confirm is false) or shows a confirmation dialog (if 
 * confirm is true) to confirm a deletion operation.
 */
const DeleteButton = (props: IProps) => {
  const dialog = useConfirm();

  const handleDelete = () => {
    props.onClick();
  }

  const handleClick = () => {
    if(props.confirm) {
      dialog.start(handleDelete, props.title, props.text);
    } else {
      handleDelete();
    }
  }

  return (
    <SecondaryButton 
      onClick={handleClick}
      title={props.title}
      negative
      icon={{ animated: props.active, url: props.active ? SVG.Icons.CircleNotch : SVG.Icons.Delete }}
    />
  );
}

export { DeleteButton }
